import React, { useEffect, useState } from "react";
import { TextInput } from "../Shared/Inputs/TextInput";
import { Button } from "../Shared/Buttons/Button";
import { ReactComponent as CloseIcon } from '../../assets/svg/black_close-circle.svg';
import { ResponseModel } from "../../models/ResponseModel";
import { useAlert } from "../../hooks/useAlert";
import { LoggedRecruiter } from '../../models/LoggedRecruiter';
import { addBlueLotusPartner, getBlueLotusPartners, removeBlueLotusPartner } from "../../services/RecruiterService";
import useErrorPage from '../../hooks/useErrorPage';
import { BlueLotusPartner } from '../../models/BlueLotusPartner';
import { IntegrationLoader } from "../Loaders/IntegrationLoader";
import { UserType } from "../../enums/UserType";

interface Props {
    styles?: any;
    recruiter: LoggedRecruiter;
};

export const BlueLotus: React.FC<Props> = (props) => {
    const styles = props.styles;
    const recruiter = props.recruiter;
    const { Alert, openAlert } = useAlert();
    const [toErrorPage] = useErrorPage();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [partnerList, setPartnerList] = useState<BlueLotusPartner[]>([]);
    const initionalPartner : BlueLotusPartner = {
        organizationId: recruiter.organizationId,
        blueLotusPartnerId : 0,
        partnerId: ""
    }
    const [partner, setPartner] = useState<BlueLotusPartner>(initionalPartner);
    
    useEffect(() => {
        getPartners();
    }, [])

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;
        setPartner((values: any) => ({ ...values, [name]: value }));
    }

    const handleInputBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;
        setPartner((values: any) => ({ ...values, [name]: value }));
    }
    
    async function getPartners() {
        setIsLoading(true);
        await getBlueLotusPartners(recruiter.recruiterId, recruiter.organizationId, recruiter.token)
        .then((blueLotusPartners: BlueLotusPartner[]) => {
            setPartnerList(blueLotusPartners);
            setIsLoading(false);
        })  
        .catch((error) => {   
            toErrorPage(error, UserType.Recruiter);         
        });
    }

    async function addNewPratner(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        setIsLoading(true);
        await addBlueLotusPartner(partner, recruiter.recruiterId, recruiter.token)
        .then((response: ResponseModel) => {
            openAlert(response.status ? "success" : "error", response.message);
            setPartnerList(response.data);   
            setPartner(initionalPartner);    
        })
        .catch(() => {
            openAlert("error", "Enter a valid Partner ID");
        })
        .finally(() => {
            setIsLoading(false);
        })
    }

    async function removePartner(partnerId: string) {
        setIsLoading(true);
        await removeBlueLotusPartner(partnerId, recruiter.recruiterId, recruiter.token)
        .then((response: ResponseModel) => {
            openAlert(response.status ? "success" : "error", response.message);
            if(response.status){
                setPartnerList((prevList) => prevList.filter((p) => p.partnerId !== partnerId));
            }   
        })
        .catch(() => {
            openAlert("error", "There was an error during the process!")
        })
        .finally(() => {
            setIsLoading(false);
        })
    }

    return(
        <>
            <div style={styles.mainWrapper}>
                <div style={styles.headerText}>{'Connect Partner ID to Export Data to Blue Lotus 360 HRM'}</div>
                {partnerList.length === 0 && <>
                    <div style={styles.inputLabel}>{'Add new Partner ID'}</div>
                    <TextInput
                        inputType={"text"}
                        value={partner?.partnerId}
                        name={"partnerId"}
                        styles={styles.textInput}
                        handleChange={handleInputChange}
                        handleBlur={handleInputBlur}
                    />
                    <Button style={styles.submitButton} onClick={addNewPratner}>{'ADD NEW ID'}</Button>
                </>}
                <hr style={styles.line}/>
                <div style={styles.inputLabel}>{'Blue Lotus Partner ID'}</div>
                {isLoading ? <IntegrationLoader  styles={styles.loader}/> : 
                <div style={styles.domainContent}>
                   {partnerList?.map((part, index) => (
                        <div key={index} style={styles.domains}>{part.partnerId}
                            <CloseIcon style={styles.closeIcon} onClick={()=>removePartner(part.partnerId)}/>
                        </div> 
                    ))}   
                </div>}  
            </div>
            <Alert/>
        </>
    )
}